export enum analyticsEventNames {
  MEASURED_POINT_SEARCH = 'MEASURED_POINT_SEARCH',
  MEASURED_POINT_INTERACTION = 'MEASURED_POINT_INTERACTION',
  DOWNLOAD_FILTERED_MEASURED_POINT_DATA_AS_FILE = 'DOWNLOAD_FILTERED_MEASURED_POINT_DATA_AS_FILE',
  DOWNLOAD_MEASURED_POINTS_DATA_AS_FILE = 'DOWNLOAD_MEASURED_POINTS_DATA_AS_FILE',
  SURFACE_FILTERS_SAVED_FORMAT = 'SURFACE_FILTERS_SAVED_FORMAT',
  SURFACE_PANEL_INFO_SAVED_FORMAT = 'SURFACE_PANEL_INFO_SAVED_FORMAT',
  SURFACE_DISPLAY_CLICKED_COUNT = 'SURFACE_DISPLAY_CLICKED_COUNT',
  SURFACES_LOG_FILTER_METADATA = 'SURFACES_LOG_FILTER_METADATA',
  SURFACE_DETAIL_PANEL_OPENED = 'SURFACE_DETAIL_PANEL_OPENED',
}
